import React, {Component} from 'react';
import PropTypes from 'prop-types';
// import styled from "styled-components";
import {Button, Flex, Box} from 'rebass'
import Modal from "styled-react-modal";



const DefaultButton = (props) => (
	<Button variant={'main'} {...props}>Add New</Button>
)

const DefaultCloseButton = (props) => (
	<Button variant={'main'} {...props}>Close</Button>
)


const StyledModal = Modal.styled`
	padding: 8px;
  width: auto;
  height: auto;
  display: flex;
  max-height: 600px;
  overflow: auto;
  // align-items: center;
  justify-content: center;
  background-color: white;
  opacity: ${props => props.opacity};
  transition: opacity ease 500ms;
`;

class BaseModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			opacity: 0
		};

		this.toggleModal = this.toggleModal.bind(this);
		this.afterOpen = this.afterOpen.bind(this);
		this.beforeClose = this.beforeClose.bind(this);
	}

	toggleModal(e) {
		this.setState({ isOpen: !this.state.isOpen });
	}

	afterOpen() {
		setTimeout(() => {
			this.setState({ opacity: 1 });
		});
	}

	beforeClose() {
		/* return new Promise(resolve => {
			this.setState({ opacity: 0 });
			setTimeout(resolve, 200);
		}); */
	}

	render() {


		const {children, isForm, handleSubmit, OpenButton, CloseButton, hideButtons, FormComponent, initialValues} = this.props;
		return (
			<div>
				<OpenButton onClick={this.toggleModal}/>
				<StyledModal
					isOpen={this.state.isOpen}
					afterOpen={this.afterOpen}
					beforeClose={this.beforeClose}
					onBackgroundClick={this.toggleModal}
					onEscapeKeydown={this.toggleModal}
					opacity={this.state.opacity}
					backgroundProps={{ opacity: this.state.opacity }}
				>
					{isForm ?
						<Box p={3}>
						<FormComponent
							toggleOverlay={this.toggleModal}
							onSubmit={(values) => {
								handleSubmit(values)
								this.toggleModal()
							}}
							initialValues={initialValues}
						/>
						</Box>
						:
						<Flex flexDirection={'column'} flexWrap={'wrap'}>
							{children}
							{!hideButtons &&
							<Box width={1}>
								<CloseButton onClick={this.toggleModal}/>
							</Box>

							}
						</Flex>
					}

				</StyledModal>
			</div>
		);
	}
}

BaseModal.propTypes = {
	isForm: PropTypes.bool,
	hideButtons: PropTypes.bool,
	OpenButton: PropTypes.element,
	CloseButton: PropTypes.element,
	buttonText: PropTypes.string,
	FormComponent: PropTypes.func,
	handleSubmit: PropTypes.func,
	initialValues: PropTypes.object,
};

BaseModal.defaultProps = {
	isForm: false,
	hideButtons: false,
	OpenButton: DefaultButton,
	CloseButton: DefaultCloseButton,
	buttonText: 'Open modal',
	// children: DefaultChilcdren,
	handleSubmit: (values) => console.log(values)
};

export default BaseModal;
